import '../static/css/header.css'
import '../static/css/common.css'
import {useNavigate} from "react-router-dom";
import {isPc} from "../static/js/common";
import {useState} from "react";

export const Header = ({rightCancel}) => {

  const navigate = useNavigate();

  return (
    <div className={'header flex-1 flex-row'}>
      <div className={'flex-1'}>
        <div onClick={() => {
          navigate('/')
          window.scrollTo(0, 0)
        }}>
          <img style={{width: isPc ? '8vw' : '25vw', marginTop: -6}} src={require('../assets/images/logo.png')} />
        </div>
      </div>
      <div className={'flex-1 flex-end'} style={{marginRight: isPc ? 0 : 10}}>
        {rightCancel ?
          <div onClick={() => navigate(-1)}>
            <img className={isPc ? 'icon-36' : 'icon-20'} src={require('../assets/images/cancel.png')}/>
          </div>
          :
          <div onClick={() => navigate('/nav')}>
            <img className={isPc ? 'icon-32' : 'icon-20'} src={require('../assets/images/nav.png')}/>
          </div>
        }
      </div>
    </div>
  )
}
